module.exports = __webpack_public_path__ + "static/media/listIconPoi2.a08d1f9d.svg";